import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import App from './App';
import './index.css';

// Handle initial path from routing fallback
function AppWithInitialPath() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Check for initial path from our routing fallback script
    const initialPath = (window as any)._initialPath;
    if (initialPath) {
      // Clear the initial path
      delete (window as any)._initialPath;
      // Navigate to the initial path
      navigate(initialPath, { replace: true });
    }
  }, [navigate]);

  return <App />;
}

// Remove Router from App.tsx since we're providing it here
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AppWithInitialPath />
    </BrowserRouter>
  </StrictMode>
);
